<template>
    <div id="div_selSrvcUseFcltPopup"><!-- 너비지정 -->
        <div class="layer-content common"  style="height:310px;overflow-y:scroll">
            <div class="info2">서비스를 이용할 원을 선택해주세요.</div>
            <div class="btn-wrap mgt10">
                <button class="big wp100 mg0 mgt10 _bt-bline"
                        @click="srvcReqFcltClick(null)">
                    <span>+ 원 신규등록</span>
                </button>
                <button v-for="(mberRegFcltInfo,index) in mberRegFcltList"
                        :key="'mberRegFcltInfo' + index"
                        :class="['mg0 mgt10 wp100 __layer-type01']"
                        @click="srvcReqFcltClick(mberRegFcltInfo)">
                    <span v-text="mberRegFcltInfo.fcltNm"></span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'selSrvcUseFclt_popup',
        props: ['index','param'],
        data: function(){
            return {
                mberRegFcltList: new Array(),
                reqSrvcList: new Array(),
                selCallBackFunc: null
            }
        },
        computed: {
            mberInfo: function(){
                return this.$store.getters.getMberInfo;
            }
        },
        methods: {
            srvcReqFcltClick: function(mberRegFcltInfo){
                const _this = this;
                if(mberRegFcltInfo == null){
                    this.selCallBackFunc(2,null);
                    this.$store.commit('closePopup',this.index);
                }else{
                    this.axios.post('/i5gam/srvc/searchMberFcltSrvcGoodsList.act',{
                        mberNo  : this.mberInfo.mberNo,
                        fcltcd : mberRegFcltInfo.fcltcd,
                        srvcList : this.reqSrvcList
                    }).then(function(response) {
                        const mberFcltSrvcGoodsList = response.data.mberFcltSrvcGoodsList;

                        if(mberFcltSrvcGoodsList.length > 0){
                            this.$toasted.show("이미 서비스 신청이 완료된 원입니다.");
                        }else{
                            this.selCallBackFunc(3,mberRegFcltInfo);
                            this.$store.commit('closePopup',this.index);
                        }
                    }.bind(this)).catch(function(e) {
                        console.log(e);
                        _this.$toasted.show(_this.$onbiLib.msg.err.system);
                    });
                }
            }
        },
        mounted: function (){
            this.mberRegFcltList = this.param.mberRegFcltList;
            this.reqSrvcList = this.param.reqSrvcList;
            this.selCallBackFunc = this.param.selCallBackFunc;
        },
    }
</script>

<style scoped>

</style>